import { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { Context } from './CreateNotice';
import SearchWindow from './common/SearchWindow';
import SortButton from './common/SortButton';
import { SORT_CATEGORIES } from '../common/constants';

import { useTheme } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const ReceiverSelectDialog = () => {
  const { typography } = useTheme();
  const styles = {
    tableHead: {
      ...typography.body14bold,
      color: 'darkgray',
    },
    checkBox: {
      textAlign: 'center',
      width: '50px',
      padding: '0px',
    },
  };
  const [allUsers, setAllUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchText, setSearchText] = useState('');
  const { openSelectReceiver, setOpenSelectReceiver, receivers, setReceivers } = useContext(Context);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get('/v1/users/receivers');
        setAllUsers(data);
      } catch (err) { }
    };
    // モーダルを開いた時だけ実行する
    if (openSelectReceiver) {
      fetchData();
    }
  }, [openSelectReceiver]);

  useEffect(() => {
    // ユーザーが更新されたときに、選択中かつ存在しないユーザーを削除する処理
    // 毎回選択先ダイアログを開くたびにチェックされる
    const activeEmployeeNumbers = allUsers.map((user) => user.employeeNumber);
    const newReceivers = receivers.filter((v) => {
      return activeEmployeeNumbers.includes(v.employeeNumber);
    });
    setReceivers(newReceivers);
  }, [allUsers]);

  useEffect(() => {
    // テーブルに表示するユーザー一覧（searchTextが空の場合は全件表示）
    const filtered = allUsers.filter((user) => (user.employeeNumber + user.name).includes(searchText));
    setFilteredUsers(filtered);
  }, [allUsers, searchText]);

  const handleSelect = (employeeNumber, isSelected) => {
    const targetUser = allUsers.find((user) => user.employeeNumber === employeeNumber);
    if (!isSelected) {
      setReceivers([...receivers, targetUser]);
    } else {
      setReceivers(receivers.filter((v) => v.employeeNumber !== employeeNumber));
    }
  };

  const handleSelectAll = (_, checked) => {
    const target = checked ? filteredUsers : [];
    setReceivers(target);
  };

  const handleClose = () => {
    setOpenSelectReceiver(false);
    setSearchText('');
  };

  return (
    <Dialog
      open={openSelectReceiver}
      onClose={handleClose}
      fullWidth
      maxWidth='sm'
    >

      <DialogTitle variant='body16bold' textAlign='center' position='relative'>
        送信先（運転士トレーニングアカウント）
        <IconButton
          sx={{ position: 'absolute', right: '6px', top: '0px', bottom: '0px' }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Stack direction='row' alignItems='center' marginBottom='16px'>
          <SearchWindow searchText={searchText} setSearchText={setSearchText} />
          <DialogContentText variant='body14' sx={{ marginLeft: '16px' }}>
            {searchText ? `検索結果 ${filteredUsers.length}件/${allUsers.length}件` : `全${allUsers.length}件`}
          </DialogContentText>
          <SortButton
            items={[
              SORT_CATEGORIES.EMPLOYEE_NUMBER_ASC,
              SORT_CATEGORIES.EMPLOYEE_NAME_ASC,
            ]}
            initialItem={SORT_CATEGORIES.EMPLOYEE_NUMBER_ASC}
            tableData={allUsers}
            setTableData={setAllUsers}
          />
        </Stack>
        <TableContainer sx={{ height: '400px' }}>
          <Table >
            <TableHead>
              <TableRow>
                <TableCell sx={styles.checkBox}>
                  <Checkbox
                    onChange={handleSelectAll}
                    checked={receivers.length > 0 && JSON.stringify(filteredUsers) === JSON.stringify(receivers)}
                  />
                </TableCell>
                <TableCell width='100px' sx={styles.tableHead}>社員番号</TableCell>
                <TableCell sx={styles.tableHead}>氏名</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredUsers.map((user) => {
                const isSelected = !!receivers.map((v) => v.employeeNumber).includes(user.employeeNumber);
                return (
                  <TableRow
                    key={user.employeeNumber} hover
                    onClick={() => {
                      handleSelect(user.employeeNumber, isSelected);
                    }}
                  >
                    <TableCell sx={styles.checkBox}>
                      <Checkbox
                        value={user.employeeNumber}
                        checked={isSelected}
                      />
                    </TableCell>
                    <TableCell sx={typography.body14}>{user.employeeNumber}</TableCell>
                    <TableCell sx={typography.body14}>{user.name}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <Stack direction='row' alignItems='center' justifyContent='center' marginTop='8px'>
          <InfoOutlinedIcon sx={{ width: '20px', height: '20px', marginRight: '8px' }} />
          <Typography variant='body14' color='darkgray'>
            タブレットアプリで運転開始中のアカウントのみが表示されています。
          </Typography>
        </Stack>
        <Button
          variant='contained' fullWidth disableElevation sx={{ marginTop: '16px' }}
          onClick={handleClose}
        >
          閉じる
        </Button>
      </DialogContent>

    </Dialog >
  );
};

export default ReceiverSelectDialog;
